import { render, staticRenderFns } from "./order-delivery.vue?vue&type=template&id=1631f92d&scoped=true"
import script from "./order-delivery.vue?vue&type=script&lang=js"
export * from "./order-delivery.vue?vue&type=script&lang=js"
import style0 from "./order-delivery.vue?vue&type=style&index=0&id=1631f92d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1631f92d",
  null
  
)

export default component.exports